import { z } from "zod";

export const isoDateTimeSchema = z.string().datetime({ offset: true });
export const opaqueIdSchema = z.string().trim().min(1).max(200);
export const versionSchema = z.string().trim().min(1).max(100);
export const permissionKeySchema = z
  .string()
  .trim()
  .regex(/^[a-z][a-z0-9_]*(?:\.[a-z][a-z0-9_]*)+$/, "Invalid permission key")
  .max(160);
export const entitlementKeySchema = z
  .string()
  .trim()
  .regex(/^[a-z][a-z0-9_-]*(?:\.[a-z][a-z0-9_-]*)*$/, "Invalid entitlement key")
  .max(160);

export const jsonPrimitiveSchema = z.union([z.string(), z.number(), z.boolean(), z.null()]);
export type JsonPrimitive = z.infer<typeof jsonPrimitiveSchema>;
export type JsonValue = JsonPrimitive | JsonValue[] | { [key: string]: JsonValue };

export const jsonValueSchema: z.ZodType<JsonValue> = z.lazy(() =>
  z.union([jsonPrimitiveSchema, z.array(jsonValueSchema), z.record(jsonValueSchema)]),
);

